import { render, staticRenderFns } from "./ClaimEmailed.vue?vue&type=template&id=3d81b144&scoped=true&"
import script from "./ClaimEmailed.vue?vue&type=script&lang=js&"
export * from "./ClaimEmailed.vue?vue&type=script&lang=js&"
import style0 from "./ClaimEmailed.vue?vue&type=style&index=0&id=3d81b144&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d81b144",
  null
  
)

export default component.exports